import { lazy } from 'react';

export const TrackPage = lazy(() => import('./controller.js'));
